import Button from 'components/Button';
import Modal from 'components/Modal';
import Select from 'components/Select';
import Typography from 'components/Typography';
import {get} from 'lodash';
import styles from './CardModal.module.scss';
import toast from 'react-hot-toast';
import {useState} from 'react';
import classNames from 'classnames';
import {formatPrice} from 'utils/format-price';
import {DataTableSchemaItem} from 'types';
import DataTable from 'components/DataTable';

interface CardModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedCard: any;
  setCardIs: (cardId: string) => void;
  cards: any[];
  cardId: string;
  chargeCard: (data: any) => Promise<any>;
  customerId: string;
  prescriptions: any[];
  copayItems: any[];
  orderItems: any[];
  scheme: DataTableSchemaItem[];
}

export default function CardModal({
  isOpen,
  onClose,
  selectedCard,
  setCardIs,
  cards,
  cardId,
  chargeCard,
  customerId,
  prescriptions,
  copayItems,
  orderItems,
  scheme,
}: CardModalProps) {
  const [isCharging, setIsCharging] = useState(false);
  const submitSelectedCard = async () => {
    if (!cardId) {
      return;
    }
    try {
      setIsCharging(true);
      await chargeCard({
        customer: customerId,
        payment_method_uuid: cardId,
        copay_items: prescriptions?.filter((item) => !item.is_paid),
      });
      onClose();
      toast.success('Successfully');
    } catch (error) {
      toast.error('Error try again');
    } finally {
      setIsCharging(false);
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} className={styles.list_wrapper}>
      <Typography component="p" className={styles.modalDesc} variant="h2">
        Confirm Card for Charge
      </Typography>
      <Select
        styles={{
          control: (base) => ({
            ...base,
            marginTop: 20,
          }),
        }}
        placeholder="Select card"
        value={
          selectedCard && {
            label:
              (get(selectedCard, 'cardholder_name', '') || ' **** **** ****') +
              ' - ' +
              selectedCard?.last4 +
              (get(selectedCard, 'is_primary') ? ' / Primary' : ''),
            value: selectedCard?.custom_uuid,
          }
        }
        onChange={(value) => {
          if (value) setCardIs(value.value as string);
        }}
        options={cards.map((item) => ({
          label:
            (get(item, 'cardholder_name', '') || ' **** **** ****') +
            ' - ' +
            +get(item, 'last4', '') +
            ' ' +
            (get(item, 'is_primary') ? ' / Primary' : ''),
          value: item.custom_uuid,
        }))}
      />

      <div className={classNames(styles.row, styles.totalAmount)}>
        <Typography variant="h3">Order Items</Typography>
        <Typography variant="h3">
          Total:&nbsp;
          {formatPrice(
            copayItems.reduce(
              (pr: number, curr: any) => pr + Number(curr.amount_due),
              0
            )
          )}
        </Typography>
      </div>
      <DataTable schema={scheme} data={orderItems || []} />

      <div className={styles.actions}>
        <Button
          type="submit"
          onClick={submitSelectedCard}
          size="md"
          loading={isCharging}
          disabled={copayItems?.length === 0 || isCharging}
        >
          Submit
        </Button>
      </div>
    </Modal>
  );
}
